// src/components/AddStageButton/AddStageButton.jsx
import React from "react";
import PropTypes from "prop-types";
import "./AddStageButton.scss";

export default function AddStageButton({ onClick, title = " Add status" }) {
  return (
    <button className="add-stage-btn" type="button" onClick={onClick} title={title}>
      <span className="plus" style={{color:"#fff"}}>＋</span>
      <span className="txt">{title}</span>
    </button>
  );
}

AddStageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};
